import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { FieldTemplateMap } from '../models';
import { FormTemplateMapActions, FormTemplateMapActionTypes } from '../actions';

export interface FormTemplateMapState extends EntityState<FieldTemplateMap> {
  totalCount: number;
  query: QueryParamsModel;
  pageLoading: boolean;
  actionLoading: boolean;
  showInitWaitingMessage: boolean;
  error: any;
}

export const adapter: EntityAdapter<FieldTemplateMap> = createEntityAdapter<FieldTemplateMap>({
  selectId: (formTemplateMap) => formTemplateMap.id,
});

export const initialFormTemplateMapState: FormTemplateMapState = adapter.getInitialState({
  totalCount: 0,
  query: new QueryParamsModel({}),
  pageLoading: false,
  actionLoading: false,
  showInitWaitingMessage: true,
  error: null,
});

export function formTemplateMapReducer(
  state = initialFormTemplateMapState,
  action: FormTemplateMapActions,
): FormTemplateMapState {
  switch (action.type) {
    case FormTemplateMapActionTypes.ToggleFormTemplateMapPageLoading:
      return { ...state, pageLoading: action.payload.pageLoading };

    case FormTemplateMapActionTypes.ToggleFormTemplateMapActionLoading:
      return { ...state, actionLoading: action.payload.actionLoading };

    case FormTemplateMapActionTypes.LoadFormTemplateMapPage:
      return adapter.addMany(action.payload.formTemplateMaps, {
        ...initialFormTemplateMapState,
        totalCount: action.payload.totalCount,
        query: action.payload.query,
        showInitWaitingMessage: false,
      });

    case FormTemplateMapActionTypes.CancelFormTemplateMapPage:
      return { ...state, query: new QueryParamsModel({}) };

    case FormTemplateMapActionTypes.CreateFormTemplateMap:
      return adapter.addOne(action.payload.formTemplateMap, state);

    case FormTemplateMapActionTypes.UpdateFormTemplateMap:
      return adapter.updateOne(action.payload.formTemplateMap, state);

    case FormTemplateMapActionTypes.ThrowFormTemplateMapError:
      return {
        ...state,
        pageLoading: false,
        actionLoading: false,
        error: action.payload.error,
      };

    case FormTemplateMapActionTypes.ClearFormTemplateMapError:
      return { ...state, error: null };

    default:
      return state;
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
